import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditScenarioComponent implements OnInit {

  public pageId = 0;

  name = ''
  scenario = ''
  department_id = '';
  public departments: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.pageId = params['id'];
    });

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDepartments(tmpToken.accessToken)
    .then(value => {
      this.departments.push(value)
    })
    .catch(err => {
      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })

    this.rest.getScenario(tmpToken.accessToken, this.pageId)
      .then(value => {
        let val: any = value;
        this.name = val[0].name
        this.scenario = val[0].scenario
        this.department_id = val[0].department_id
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }


  save() {
    if (!this.name) {
      return
    }
    
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let scenario = {
      name : this.name,
      scenario : this.scenario,
      department_id : this.department_id
    }

    this.rest.putScenario(tmpToken.accessToken, scenario, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/scenarios');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  delete() {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.delScenario(tmpToken.accessToken, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/scenarios');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  cancel() {
    this.router.navigateByUrl('/scenarios');
  }
}
